import { render, staticRenderFns } from "./wong-baker.vue?vue&type=template&id=b56b900e&scoped=true&"
import script from "./wong-baker.vue?vue&type=script&lang=js&"
export * from "./wong-baker.vue?vue&type=script&lang=js&"
import style0 from "./wong-baker.vue?vue&type=style&index=0&id=b56b900e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56b900e",
  null
  
)

component.options.__file = "wong-baker.vue"
export default component.exports